<template>
    <v-container fluid style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.AdministracionPaginas') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
            <v-col cols="12">
                <v-expansion-panels v-model="panel">
                    <v-expansion-panel name="QuienesSomos">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{ $t('Menu.QuienesSomos') }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" align="center">
                                        <h2 class="display-2">{{ $t('Menu.QuienesSomos') }}</h2>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <v-btn color="black white--text" @click="verPagina('QuienesSomos')">{{ $t('Formularios.VerPagina') }}</v-btn>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEs') }}</h2>
                                        <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                        <vue-editor style="word-break:break-word;" id="contenidoEsQuienesSomos" v-model="contenidoEsQuienesSomos" useCustomImageHandler @image-added="handleImageAdded" />
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEn') }}</h2>
                                        <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                        <vue-editor style="word-break:break-word;" id="contenidoEnQuienesSomos" v-model="contenidoEnQuienesSomos" useCustomImageHandler @image-added="handleImageAdded" />
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <v-dialog v-model="dialogEquipo">
                                            <v-card>
                                                <v-container style="margin: 0 10%">
                                                    <v-row>
                                                        <v-col cols="12" align="center">
                                                            <h1 v-if="miembroNuevo">{{ $t('Formularios.NuevoMiembro') }}</h1>
                                                            <h1 v-else>{{ $t('Formularios.EditarMiembro') }}</h1>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-text-field solo v-model="nombreMiembro" :label="$t('Formularios.Nombre')" :hint="$t('Formularios.Nombre')" persistent-hint/>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-file-input solo v-model="preImagenMiembro" :loading="getCargandoAccion" @change="subirImagenMiembro()" :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')" persistent-hint/>
                                                        </v-col>
                                                        <v-col cols="12" align="center" v-if="imagenMiembro">
                                                            <v-avatar size="150">
                                                                <v-img :src="imagenMiembro" />
                                                            </v-avatar>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-text-field style="word-break:break-word;" solo v-model="descripcionMiembro" :label="$t('Formularios.Descripcion')" :hint="$t('Formularios.Descripcion')" persistent-hint/>
                                                        </v-col>
                                                        <v-col cols="12">
                                                             <v-textarea solo v-model="resenaMiembroEs" :label="$t('Formularios.ResenaSpanish')" :hint="$t('Formularios.ResenaSpanish')" persistent-hint/>
                                                        </v-col>
                                                         <v-col cols="12">
                                                             <v-textarea solo v-model="resenaMiembroIn" :label="$t('Formularios.ResenaEnglish')" :hint="$t('Formularios.ResenaEnglish')" persistent-hint/>
                                                        </v-col>
                                                        <v-col cols="12" align="center">
                                                            <v-btn :loading="getCargandoAccion" @click="actualizarMiembro()" color="black white--text" x-large style="min-width:20%!important">{{$t('Formularios.Actualizar')}}</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card>
                                        </v-dialog>
                                        <v-data-table
                                        :headers="headersEquipo"
                                        :items="equipoQuienesSomos">
                                            <template v-slot:top>
                                                <v-toolbar flat color="white">
                                                    <v-toolbar-title>{{ $t('Inicio.Equipo') }}</v-toolbar-title>
                                                    <v-divider
                                                    class="mx-4"
                                                    inset
                                                    vertical
                                                    ></v-divider>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="black white--text" @click="abrirDialogEquipo('nuevo')">{{ $t('Formularios.NuevoMiembro') }}</v-btn>
                                                </v-toolbar>
                                            </template>
                                            <template v-slot:[`item.src`]="{ item }">
                                                <v-avatar size="60" class="ma-1">
                                                    <v-img :src="item.src" />
                                                </v-avatar>
                                            </template>
                                            <template v-slot:[`item.acciones`]="{ item }">
                                                <v-icon class="mx-2" color="black" @click="abrirDialogEquipo('editar', item)">far fa-edit</v-icon>
                                                <v-icon class="mx-2" color="black" @click="eliminarMiembro(item)">far fa-trash-alt</v-icon>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarQuienesSomos()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="EnviosYDevoluciones">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{ $t('Menu.EnviosYDevoluciones') }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" align="center">
                                        <h2 class="display-2">{{ $t('Menu.EnviosYDevoluciones') }}</h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-dialog v-model="dialogEnvios">
                                            <v-card>
                                                <v-card-title>
                                                    <v-container>
                                                        <v-row>
                                                            <v-col cols="12" align="center">
                                                                <h1 v-if="envioNuevo">{{ $t('Formularios.NuevaSeccion') }}</h1>
                                                                <h1 v-else>{{ $t('Formularios.EditarSeccion') }}</h1>
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-text-field solo v-model="nuevaSeccion.tituloEs" :label="$t('Formularios.TituloEs')" :hint="$t('Formularios.TituloEs')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-text-field solo v-model="nuevaSeccion.tituloEn" :label="$t('Formularios.TituloEn')" :hint="$t('Formularios.TituloEn')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-textarea style="word-break:break-word;" solo v-model="nuevaSeccion.descripcionEs" :label="$t('Formularios.DescripcionEs')" :hint="$t('Formularios.DescripcionEs')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-textarea style="word-break:break-word;" solo v-model="nuevaSeccion.descripcionEn" :label="$t('Formularios.DescripcionEn')" :hint="$t('Formularios.DescripcionEn')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12" align="center">
                                                                <v-btn v-if="envioNuevo" color="black white--text" style="min-width:20%!important" x-large @click="nuevoEnvio()" :loading="getCargandoAccion">{{$t('Formularios.Publicar')}}</v-btn>
                                                                <v-btn v-else color="black white--text" style="min-width:20%!important" x-large @click="actualizarEnvio()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-card-title>
                                            </v-card>
                                        </v-dialog>
                                        <v-data-table
                                        :headers="headerEnvios"
                                        :items="envios"
                                        id="envios"
                                        ref="sortableTable">
                                            <template v-slot:top>
                                                <v-toolbar flat color="white">
                                                    <v-toolbar-title>{{ $t('Menu.EnviosYDevoluciones') }}</v-toolbar-title>
                                                    <v-divider
                                                    class="mx-4"
                                                    inset
                                                    vertical
                                                    ></v-divider>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="black white--text" @click="abrirDialogEnvios('nuevo')">{{ $t('Formularios.NuevaSeccion') }}</v-btn>
                                                </v-toolbar>
                                            </template>
                                             <template v-slot:body="{ items }">
                                              <tbody>
                                                <tr class="sortableRow" v-for="(item1) in items" :key="itemKey(item1)">
                                                  <td class="sortHandle">
                                                    <v-btn icon style="cursor: move" class="handle2"><v-icon>fas fa-grip-lines</v-icon></v-btn>
                                                  </td>
                                                  <td class="text-xs-center">
                                                    <span v-if="getIdioma === 'es'" class="handle2">{{ item1.tituloEs }}</span>
                                                    <span v-else class="handle2">{{ item1.tituloEn }}</span>
                                                  </td>
                                                  <td class="text-xs-center">
                                                    <v-icon class="mx-2" color="black" @click="abrirDialogEnvios('editar', item1)('editar', item1)">far fa-edit</v-icon>
                                                    <v-icon class="mx-2" color="black" @click="eliminarEnvio(item1)">far fa-trash-alt</v-icon>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </template>
                                            <!-- <template v-slot:item.sort>
                                              <v-btn icon style="cursor: move" class="handle2"><v-icon>fas fa-grip-lines</v-icon></v-btn>
                                            </template>
                                            <template v-slot:item.titulo="{ item }">
                                                <span v-if="getIdioma === 'es'">{{ item.tituloEs }}</span>
                                                <span v-else>{{ item.tituloEn }}</span>
                                            </template>
                                            <template v-slot:item.acciones="{ item }">
                                                <v-icon class="mx-2" color="black" @click="abrirDialogEnvios('editar', item)">far fa-edit</v-icon>
                                                <v-icon class="mx-2" color="black" @click="eliminarEnvio(item)">far fa-trash-alt</v-icon>
                                            </template> -->
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                                  <v-col cols="12" align="center">
                                    <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarSeccionEnvios()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                  </v-col>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="Faq">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.Faq')}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container>
                                <v-row>
                                    <v-col cols="12" align="center">
                                        <h2 class="display-2">{{ $t('Menu.Faq') }}</h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-dialog v-model="dialogFaq">
                                            <v-card>
                                                <v-card-title>
                                                    <v-container>
                                                        <v-row>
                                                            <v-col cols="12" align="center">
                                                                <h1 v-if="faqNuevo">{{ $t('Formularios.NuevaSeccion') }}</h1>
                                                                <h1 v-else>{{ $t('Formularios.EditarSeccion') }}</h1>
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-text-field solo v-model="nuevaSeccionFaq.tituloEs" :label="$t('Formularios.TituloEs')" :hint="$t('Formularios.TituloEs')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-text-field solo v-model="nuevaSeccionFaq.tituloEn" :label="$t('Formularios.TituloEn')" :hint="$t('Formularios.TituloEn')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-textarea style="word-break:break-word;" solo v-model="nuevaSeccionFaq.descripcionEs" :label="$t('Formularios.DescripcionEs')" :hint="$t('Formularios.DescripcionEs')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-textarea style="word-break:break-word;" solo v-model="nuevaSeccionFaq.descripcionEn" :label="$t('Formularios.DescripcionEn')" :hint="$t('Formularios.DescripcionEn')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12" align="center">
                                                                <v-btn v-if="faqNuevo" color="black white--text" style="min-width:20%!important" x-large @click="nuevoFaq()" :loading="getCargandoAccion">{{$t('Formularios.Publicar')}}</v-btn>
                                                                <v-btn v-else color="black white--text" style="min-width:20%!important" x-large @click="actualizarFaq()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-card-title>
                                            </v-card>
                                        </v-dialog>
                                        <v-data-table
                                        :headers="headerFaq"
                                        :items="faq"
                                        ref="sortableTable">
                                            <template v-slot:top>
                                                <v-toolbar flat color="white">
                                                    <v-toolbar-title>{{ $t('Menu.Faq') }}</v-toolbar-title>
                                                    <v-divider
                                                    class="mx-4"
                                                    inset
                                                    vertical
                                                    ></v-divider>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="black white--text" @click="abrirDialogFaq('nuevo')">{{ $t('Formularios.NuevaSeccion') }}</v-btn>
                                                </v-toolbar>
                                            </template>
                                            <template v-slot:body="{ items }">
                                              <tbody>
                                                <tr class="sortableRow" v-for="(item1) in items" :key="itemKey(item1)">
                                                  <td class="sortHandle">
                                                    <v-btn icon style="cursor: move" class="handle2"><v-icon>fas fa-grip-lines</v-icon></v-btn>
                                                  </td>
                                                  <td class="text-xs-center">
                                                    <span v-if="getIdioma === 'es'" class="handle2">{{ item1.tituloEs }}</span>
                                                    <span v-else class="handle2">{{ item1.tituloEn }}</span>
                                                  </td>
                                                  <td class="text-xs-center">
                                                    <v-icon class="mx-2" color="black" @click="abrirDialogFaq('editar', item1)('editar', item1)">far fa-edit</v-icon>
                                                    <v-icon class="mx-2" color="black" @click="eliminarFaq(item1)">far fa-trash-alt</v-icon>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </template>
                                            <!-- <template v-slot:[`item.sort`]>
                                              <v-btn icon style="cursor: move" class="handle3"><v-icon>fas fa-grip-lines</v-icon></v-btn>
                                            </template>
                                            <template v-slot:[`item.titulo`]="{ item }">
                                                <span v-if="getIdioma === 'es'">{{ item.tituloEs }}</span>
                                                <span v-else>{{ item.tituloEn }}</span>
                                            </template>
                                            <template v-slot:[`item.acciones`]="{ item }">
                                                <v-icon class="mx-2" color="black" @click="abrirDialogFaq('editar', item)">far fa-edit</v-icon>
                                                <v-icon class="mx-2" color="black" @click="eliminarFaq(item)">far fa-trash-alt</v-icon>
                                            </template> -->
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                                <v-col cols="12" align="center">
                                    <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarSeccionPreguntasF()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                  </v-col>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="PorQueComprar">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.PorQueComprar')}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container>
                                <v-row>
                                    <v-col cols="12" align="center">
                                        <h2 class="display-2">{{ $t('Menu.PorQueComprar') }}</h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-dialog v-model="dialogCompromisos">
                                            <v-card>
                                                <v-card-title>
                                                    <v-container>
                                                        <v-row>
                                                            <v-col cols="12" align="center">
                                                                <h1 v-if="faqNuevo">{{ $t('Formularios.NuevaSeccion') }}</h1>
                                                                <h1 v-else>{{ $t('Formularios.EditarSeccion') }}</h1>
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-textarea style="word-break:break-word;" solo v-model="nuevaSeccionCompromisos.descripcionEs" :label="$t('Formularios.DescripcionEs')" :hint="$t('Formularios.DescripcionEs')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-textarea style="word-break:break-word;" solo v-model="nuevaSeccionCompromisos.descripcionEn" :label="$t('Formularios.DescripcionEn')" :hint="$t('Formularios.DescripcionEn')" persistent-hint />
                                                            </v-col>
                                                            <v-col cols="12" align="center">
                                                                <v-btn v-if="compromisoNuevo" color="black white--text" style="min-width:20%!important" x-large @click="nuevoCompromiso()" :loading="getCargandoAccion">{{$t('Formularios.Publicar')}}</v-btn>
                                                                <v-btn v-else color="black white--text" style="min-width:20%!important" x-large @click="actualizarCompromiso()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-card-title>
                                            </v-card>
                                        </v-dialog>
                                        <v-data-table
                                        :headers="headerCompromisos"
                                        :items="compromisos"
                                        disable-sort
                                        id="compromisos"
                                        ref="sortableTable">
                                            <template v-slot:top>
                                                <v-toolbar flat color="white">
                                                    <v-toolbar-title>{{ $t('Menu.PorQueComprar') }}</v-toolbar-title>
                                                    <v-divider
                                                    class="mx-4"
                                                    inset
                                                    vertical
                                                    ></v-divider>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="black white--text" @click="abrirDialogCompromiso('nuevo')">{{ $t('Formularios.NuevaSeccion') }}</v-btn>
                                                </v-toolbar>
                                            </template>
                                             <template v-slot:body="{ items }">
                                              <tbody>
                                                <tr class="sortableRow" v-for="(item1) in items" :key="itemKey(item1)">
                                                  <td class="sortHandle">
                                                    <v-btn icon style="cursor: move" class="handle2"><v-icon>fas fa-grip-lines</v-icon></v-btn>
                                                  </td>
                                                  <td class="text-xs-center">
                                                    <span v-if="getIdioma === 'es'" class="handle2">{{ item1.descripcionEs.substring(0, 80) }}...</span>
                                                    <span v-else class="handle2">{{ item1.descripcionEn.substring(0, 80) }}...</span>
                                                  </td>
                                                  <td class="text-xs-center">
                                                    <v-icon class="mx-2" color="black" @click="abrirDialogCompromiso('editar', item1)('editar', item1)">far fa-edit</v-icon>
                                                    <v-icon class="mx-2" color="black" @click="eliminarCompromiso(item1)">far fa-trash-alt</v-icon>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </template>
                                            <!-- <template v-slot:[`item.sort`]>
                                              <v-btn icon style="cursor: move" class="handle"><v-icon>fas fa-grip-lines</v-icon></v-btn>
                                            </template>
                                            <template v-slot:[`item.titulo`]="{item}">
                                              <span v-if="getIdioma === 'es'" class="handle">{{ item.descripcionEs.substring(0, 80) }}...</span>
                                                <span v-else class="handle">{{ item.descripcionEn.substring(0, 80) }}...</span>
                                            </template>
                                            <template v-slot:[`item.acciones`]="{item}">
                                              <v-icon class="mx-2" color="black" @click="abrirDialogCompromiso('editar', item)">far fa-edit</v-icon>
                                                  <v-icon class="mx-2" color="black" @click="eliminarCompromiso(item)">far fa-trash-alt</v-icon>
                                            </template> -->
                                        </v-data-table>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                      <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarSeccionPorQueComprar()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="Club">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.Club')}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container v-if="club">
                            <v-row>
                              <v-col cols="12" align="center">
                                <h2 class="display-2">{{ $t('Menu.Club') }}</h2>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2>{{$t('Formularios.ImagenPrincipal')}}</h2>
                              </v-col>
                              <v-col cols="12">
                                  <v-file-input solo v-model="preImagenClub" :loading="getCargandoAccion" @change="subirImagenClub()" :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')" />
                              </v-col>
                              <v-col cols="12">
                                  <v-img :src="club.imagen" contain max-height="400px"/>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEs') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEsClub" v-model="club.textoEs" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEn') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEnClub" v-model="club.textoEn" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarClub()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="Empresas">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.Empresas')}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container v-if="empresas">
                            <v-row>
                              <v-col cols="12" align="center">
                                <h2 class="display-2">{{ $t('Menu.Empresas') }}</h2>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2>{{$t('Formularios.ImagenPrincipal')}}</h2>
                              </v-col>
                              <v-col cols="12">
                                  <v-file-input solo v-model="preImagenEmpresas" :loading="getCargandoAccion" @change="subirImagenEmpresas()" :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')" />
                              </v-col>
                              <v-col cols="12">
                                  <v-img :src="empresas.imagen" contain max-height="400px"/>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEs') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEsEmpresas" v-model="empresas.textoEs" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEn') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEnEmpresas" v-model="empresas.textoEn" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarEmpresas()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="Asesoria">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.Asesoria')}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container v-if="asesoria">
                            <v-row>
                              <v-col cols="12" align="center">
                                <h2 class="display-2">{{ $t('Menu.Asesoria') }}</h2>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2>{{$t('Formularios.ImagenPrincipal')}}</h2>
                              </v-col>
                              <v-col cols="12">
                                  <v-file-input solo v-model="preImagenAsesoria" :loading="getCargandoAccion" @change="subirImagenAsesoria('principal')" :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')" />
                              </v-col>
                              <v-col cols="12">
                                  <v-img :src="asesoria.imagenPrincipal" contain max-height="400px"/>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2>{{$t('Formularios.ImagenSecundaria')}}</h2>
                              </v-col>
                              <v-col cols="12">
                                  <v-file-input solo v-model="preImagenAsesoria2" :loading="getCargandoAccion" @change="subirImagenAsesoria('secundaria')" :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')" />
                              </v-col>
                              <v-col cols="12">
                                <v-switch v-model="asesoria.secundaria" label="Mostrar Imagen Secundaria" color="secondary" />
                              </v-col>
                              <v-col cols="12">
                                  <v-img :src="asesoria.imagenSecundaria" contain max-height="400px"/>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEs') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEsAsesoria" v-model="asesoria.descripcionEs" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEn') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEnAsesoria" v-model="asesoria.descripcionEn" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarAsesoria()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="Newsletter">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">Newsletter</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container v-if="newsletter">
                            <v-row>
                              <v-col cols="12" align="center">
                                <h2 class="display-2">Newsletter</h2>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2>{{$t('Formularios.ImagenPrincipal')}}</h2>
                              </v-col>
                              <v-col cols="12">
                                  <v-file-input solo v-model="preImagenNewsletter" :loading="getCargandoAccion" @change="subirImagenNewsletter()" :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')" />
                              </v-col>
                              <v-col cols="12">
                                  <v-img :src="newsletter.imagen" max-height="200px"/>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEs') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEsNewsletter" v-model="newsletter.textoEs" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEn') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEnNewsletter" v-model="newsletter.textoEn" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarNewsletter()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="Contactanos">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.Contactanos')}}</v-expansion-panel-header>
                        <v-expansion-panel-content >
                            <v-container>
                                <v-row>
                                    <v-col cols="12" align="center">
                                        <h2 class="display-2">{{ $t('Menu.Contactanos') }}</h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-file-input solo v-model="preImagenContactanos" :loading="getCargandoAccion" @change="subirImagenContactanos()" :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')" />
                                    </v-col>
                                    <v-col cols="12" v-if="imagenContactanos">
                                        <v-img :src="imagenContactanos" contain max-height="400px"/>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarContactanos()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="TyC">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.TyC')}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container v-if="tyc">
                            <v-row>
                              <v-col cols="12" align="center">
                                <h2 class="display-2">{{ $t('Menu.TyC') }}</h2>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEs') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEsTyC" v-model="tyc.descripcionEs" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEn') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEnTyC" v-model="tyc.descripcionEn" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarTyC()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="PoliticaDePrivacidad">
                        <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.PoliticaDePrivacidad')}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container v-if="politica">
                            <v-row>
                              <v-col cols="12" align="center">
                                <h2 class="display-2">{{ $t('Menu.PoliticaDePrivacidad') }}</h2>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEs') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEsPolitica" v-model="politica.descripcionEs" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEn') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEnPolitica" v-model="politica.descripcionEn" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarPolitica()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel name="PorQuéRegistrarse">
                      <v-expansion-panel-header class="vietnam title font-weight-regular">{{$t('Menu.PorQueRegistrarse')}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container v-if="pqr">
                            <v-row>
                              <v-col cols="12" align="center">
                                <h2 class="display-2">{{ $t('Menu.PorQueRegistrarse') }}</h2>
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEs') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEsPQR" v-model="pqr.descripcionEs" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.ContenidoEn') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor style="word-break:break-word;" id="contenidoEnPQR" v-model="pqr.descripcionEn" useCustomImageHandler @image-added="handleImageAdded" />
                              </v-col>
                              <v-col cols="12" align="center">
                                <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarPQR()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { VueEditor } from 'vue2-editor'
import axios from 'axios'
import Sortable from 'sortablejs'
export default {
  name: 'AdministracionPaginas',
  components: {
    VueEditor
  },
  data () {
    return {
      itemKeys: new WeakMap(),
      panel: null,
      // Quienes Somos
      contenidoEsQuienesSomos: '',
      contenidoEnQuienesSomos: '',
      equipoQuienesSomos: [],
      headersEquipo: [
        { text: this.$i18n.t('Formularios.Nombre'), value: 'nombre' },
        { text: this.$i18n.t('Formularios.Imagen'), value: 'src' },
        { text: this.$i18n.t('Formularios.Descripcion'), value: 'descripcion' },
        { text: this.$i18n.t('Formularios.ResenaSpanish'), value: 'resenaEs' },
        { text: this.$i18n.t('Formularios.ResenaEnglish'), value: 'resenaIn' },
        { text: this.$i18n.t('Formularios.Acciones'), value: 'acciones' }
      ],
      dialogEquipo: false,
      miembroNuevo: true,
      indexMiembro: null,
      nombreMiembro: '',
      preImagenMiembro: null,
      imagenMiembro: '',
      descripcionMiembro: '',
      resenaMiembroEs: '',
      resenaMiembroIn: '',
      // Envios y Devoluciones
      envios: [],
      headerEnvios: [
        { text: '', value: 'sort' },
        { text: this.$i18n.t('Formularios.Titulo'), value: 'titulo' },
        { text: this.$i18n.t('Formularios.Acciones'), value: 'acciones' }
      ],
      dialogEnvios: false,
      envioNuevo: false,
      indexEnvio: null,
      nuevaSeccion: {
        tituloEs: null,
        tituloEn: null,
        descripcionEs: null,
        descripcionEn: null
      },
      // Preguntas Frecuentes
      faq: [],
      headerFaq: [
        { text: '', value: 'sort' },
        { text: this.$i18n.t('Formularios.Titulo'), value: 'titulo' },
        { text: this.$i18n.t('Formularios.Acciones'), value: 'acciones' }
      ],
      dialogFaq: false,
      faqNuevo: false,
      indexFaq: null,
      nuevaSeccionFaq: {
        tituloEs: null,
        tituloEn: null,
        descripcionEs: null,
        descripcionEn: null
      },
      // Por Qué Comprar
      compromisos: [],
      headerCompromisos: [
        { text: '', value: 'sort' },
        { text: this.$i18n.t('Formularios.Titulo'), value: 'titulo' },
        { text: this.$i18n.t('Formularios.Acciones'), value: 'acciones' }
      ],
      dialogCompromisos: false,
      compromisoNuevo: false,
      indexCompromiso: null,
      nuevaSeccionCompromisos: {
        descripcionEs: null,
        descripcionEn: null
      },
      // Club
      club: null,
      preImagenClub: null,
      // Empresas
      empresas: null,
      preImagenEmpresas: null,
      // Asesoría y Curaduría
      asesoria: null,
      preImagenAsesoria: null,
      preImagenAsesoria2: null,
      // Newsletter
      newsletter: null,
      preImagenNewsletter: null,
      // Contactanos
      preImagenContactanos: null,
      imagenContactanos: null,
      // Términos y Condiciones
      tyc: null,
      // Política de Privacidad
      politica: null,
      // Por Qué Registrarse
      pqr: null,
      currentItemKey: 0
    }
  },
  computed: {
    ...mapGetters(['getCargandoAccion', 'getIdioma'])
  },
  methods: {
    ...mapMutations(['setCargandoAccion', 'setAlerta', 'setTextoAlerta']),
    itemKey (item) {
      console.log('Item: ', item)
      console.log('Item Key: ', this.itemKeys.has(item))
      console.log('Item Return: ', this.itemKeys.get(item))

      if (!this.itemKeys.has(item)) { this.itemKeys.set(item, ++this.currentItemKey) }
      return this.itemKeys.get(item)
    },
    // Sortable
    reorganizar1 (tipo) {
      const _self = this
      Sortable.create(_self.$refs.sortableTable.$el.getElementsByTagName('tbody')[0], {
        handle: '.handle2',
        draggable: '.sortableRow',
        onEnd ({ newIndex, oldIndex }) {
          if (tipo === 'envios') {
            _self.envios.splice(newIndex, 0, ..._self.envios.splice(oldIndex, 1))
          }
          if (tipo === 'faq') {
            _self.faq.splice(newIndex, 0, ..._self.faq.splice(oldIndex, 1))
          }
          if (tipo === 'compromisos') {
            _self.compromisos.splice(newIndex, 0, ..._self.compromisos.splice(oldIndex, 1))
          }
        }
      })
    },
    reorganizar (tipo) {
      if (tipo === 'compromisos') {
        let compromisos = document.querySelector('#compromisos tbody')
        Sortable.create(compromisos, {
          handle: '.handle'
        })
      }
      if (tipo === 'envios') {
        let envios = document.querySelector('#envios tbody')
        Sortable.create(envios, {
          handle: '.handle2'
        })
      }
      if (tipo === 'faq') {
        let faq = document.querySelector('#faq tbody')
        Sortable.create(faq, {
          handle: '.handle3'
        })
      }
    },
    // Quienes Somos
    abrirDialogEquipo (tipo, info) {
      if (tipo === 'nuevo') {
        this.nombreMiembro = null
        this.preImagenMiembro = null
        this.imagenMiembro = null
        this.descripcionMiembro = null
        this.resenaMiembroEs = null
        this.resenaMiembroIn = null
        this.miembroNuevo = true
        this.dialogEquipo = true
      } else {
        this.indexMiembro = this.equipoQuienesSomos.indexOf(info)
        this.nombreMiembro = info.nombre
        this.preImagenMiembro = null
        this.imagenMiembro = info.src
        this.descripcionMiembro = info.descripcion
        this.resenaMiembroEs = info.resenaEs
        this.resenaMiembroIn = info.resenaIn
        this.miembroNuevo = false
        this.dialogEquipo = true
      }
    },
    actualizarMiembro () {
      if (this.miembroNuevo) {
        this.equipoQuienesSomos.push({
          nombre: this.nombreMiembro,
          src: this.imagenMiembro,
          descripcion: this.descripcionMiembro,
          resenaEs: this.resenaMiembroEs,
          resenaIn: this.resenaMiembroIn
        })
        this.dialogEquipo = false
      } else {
        this.equipoQuienesSomos[this.indexMiembro].nombre = this.nombreMiembro
        this.equipoQuienesSomos[this.indexMiembro].src = this.imagenMiembro
        this.equipoQuienesSomos[this.indexMiembro].descripcion = this.descripcionMiembro
        this.equipoQuienesSomos[this.indexMiembro].resenaEs = this.resenaMiembroEs
        this.equipoQuienesSomos[this.indexMiembro].resenaIn = this.resenaMiembroIn
        this.dialogEquipo = false
      }
    },
    subirImagenMiembro () {
      this.setCargandoAccion(true)
      this.subirImagen(this.preImagenMiembro).then(url => {
        this.imagenMiembro = url
        this.setCargandoAccion(false)
      })
    },
    actualizarQuienesSomos () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('quienesSomos').update({
        contenidoEs: this.contenidoEsQuienesSomos,
        contenidoEn: this.contenidoEnQuienesSomos,
        equipo: this.equipoQuienesSomos
      }).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    eliminarMiembro (info) {
      var index = this.equipoQuienesSomos.indexOf(info)
      this.equipoQuienesSomos.splice(index, 1)
      this.setAlerta()
      this.setTextoAlerta('Alerta.InformacionActualizada')
    },
    // Envios y Devoluciones
    abrirDialogEnvios (tipo, info) {
      if (tipo === 'nuevo') {
        this.nuevaSeccion = {
          tituloEs: null,
          tituloEn: null,
          descripcionEs: null,
          descripcionEn: null
        }
        this.envioNuevo = true
        this.dialogEnvios = true
      } else {
        this.indexEnvio = this.envios.indexOf(info)
        this.nuevaSeccion = {
          tituloEs: info.tituloEs,
          tituloEn: info.tituloEn,
          descripcionEs: info.descripcionEs,
          descripcionEn: info.descripcionEn
        }
        this.envioNuevo = false
        this.dialogEnvios = true
      }
    },
    nuevoEnvio () {
      this.setCargandoAccion(true)
      this.envios.push(this.nuevaSeccion)
      firebase.firestore().collection('utilidades').doc('envios').update({
        envios: this.envios
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionPublicada')
          this.setCargandoAccion(false)
          this.dialogEnvios = false
        })
    },
    actualizarEnvio () {
      this.setCargandoAccion(true)
      this.envios[this.indexEnvio].tituloEs = this.nuevaSeccion.tituloEs
      this.envios[this.indexEnvio].tituloEn = this.nuevaSeccion.tituloEn
      this.envios[this.indexEnvio].descripcionEs = this.nuevaSeccion.descripcionEs
      this.envios[this.indexEnvio].descripcionEn = this.nuevaSeccion.descripcionEn
      firebase.firestore().collection('utilidades').doc('envios').update({
        envios: this.envios
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
          this.setCargandoAccion(false)
          this.dialogEnvios = false
        })
    },
    eliminarEnvio (item) {
      var index = this.envios.indexOf(item)
      this.envios.splice(index, 1)
      firebase.firestore().collection('utilidades').doc('envios').update({
        envios: this.envios
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionEliminada')
        })
    },
    // Preguntas Frecuentes
    abrirDialogFaq (tipo, info) {
      if (tipo === 'nuevo') {
        this.nuevaSeccionFaq = {
          tituloEs: null,
          tituloEn: null,
          descripcionEs: null,
          descripcionEn: null
        }
        this.faqNuevo = true
        this.dialogFaq = true
      } else {
        this.indexFaq = this.faq.indexOf(info)
        this.nuevaSeccionFaq = {
          tituloEs: info.tituloEs,
          tituloEn: info.tituloEn,
          descripcionEs: info.descripcionEs,
          descripcionEn: info.descripcionEn
        }
        this.faqNuevo = false
        this.dialogFaq = true
      }
    },
    nuevoFaq () {
      this.setCargandoAccion(true)
      this.faq.push(this.nuevaSeccionFaq)
      firebase.firestore().collection('utilidades').doc('faq').update({
        faq: this.faq
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionPublicada')
          this.setCargandoAccion(false)
          this.dialogFaq = false
        })
    },
    actualizarFaq () {
      this.setCargandoAccion(true)
      this.faq[this.indexFaq].tituloEs = this.nuevaSeccionFaq.tituloEs
      this.faq[this.indexFaq].tituloEn = this.nuevaSeccionFaq.tituloEn
      this.faq[this.indexFaq].descripcionEs = this.nuevaSeccionFaq.descripcionEs
      this.faq[this.indexFaq].descripcionEn = this.nuevaSeccionFaq.descripcionEn
      firebase.firestore().collection('utilidades').doc('faq').update({
        faq: this.faq
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
          this.setCargandoAccion(false)
          this.dialogFaq = false
        })
    },
    eliminarFaq (item) {
      var index = this.faq.indexOf(item)
      this.faq.splice(index, 1)
      firebase.firestore().collection('utilidades').doc('faq').update({
        faq: this.faq
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionEliminada')
        })
    },
    // Por Qué Comprar
    abrirDialogCompromiso (tipo, info) {
      if (tipo === 'nuevo') {
        this.nuevaSeccionCompromisos = {
          descripcionEs: null,
          descripcionEn: null
        }
        this.compromisoNuevo = true
        this.dialogCompromisos = true
      } else {
        this.indexCompromiso = this.compromisos.indexOf(info)
        this.nuevaSeccionCompromisos = {
          descripcionEs: info.descripcionEs,
          descripcionEn: info.descripcionEn
        }
        this.compromisoNuevo = false
        this.dialogCompromisos = true
      }
    },
    nuevoCompromiso () {
      this.setCargandoAccion(true)
      this.compromisos.push(this.nuevaSeccionCompromisos)
      firebase.firestore().collection('utilidades').doc('compromisos').update({
        compromisos: this.compromisos
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionPublicada')
          this.setCargandoAccion(false)
          this.dialogCompromisos = false
        })
    },
    actualizarCompromiso () {
      this.setCargandoAccion(true)
      this.compromisos[this.indexCompromiso].descripcionEs = this.nuevaSeccionCompromisos.descripcionEs
      this.compromisos[this.indexCompromiso].descripcionEn = this.nuevaSeccionCompromisos.descripcionEn
      firebase.firestore().collection('utilidades').doc('compromisos').update({
        compromisos: this.compromisos
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
          this.setCargandoAccion(false)
          this.dialogCompromisos = false
        })
    },
    eliminarCompromiso (item) {
      var index = this.compromisos.indexOf(item)
      this.compromisos.splice(index, 1)
      firebase.firestore().collection('utilidades').doc('compromisos').update({
        compromisos: this.compromisos
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionEliminada')
        })
    },
    actualizarPorQueComprar () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('compromisos').update(this.compromisos).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    // Club
    subirImagenClub () {
      this.setCargandoAccion(true)
      this.subirImagen(this.preImagenClub).then(url => {
        this.club.imagen = url
        this.setCargandoAccion(false)
      })
    },
    actualizarClub () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('club').update(this.club).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    // Empresas
    subirImagenEmpresas () {
      this.setCargandoAccion(true)
      this.subirImagen(this.preImagenEmpresas).then(url => {
        this.empresas.imagen = url
        this.setCargandoAccion(false)
      })
    },
    actualizarEmpresas () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('empresas').update(this.empresas).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    // Asesoría y Curaduría
    actualizarAsesoria () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('asesoria').update(this.asesoria).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    subirImagenAsesoria (tipo) {
      this.setCargandoAccion(true)
      this.subirImagen(this.preImagenAsesoria).then(url => {
        if (tipo === 'principal') {
          this.asesoria.imagenPrincipal = url
        } else {
          this.asesoria.imagenSecundaria = url
        }
        this.setCargandoAccion(false)
      })
    },
    // Newsletter
    subirImagenNewsletter () {
      this.setCargandoAccion(true)
      this.subirImagen(this.preImagenNewsletter).then(url => {
        this.newsletter.imagen = url
        this.setCargandoAccion(false)
      })
    },
    actualizarNewsletter () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('newsletter').update(this.newsletter).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    // Contactanos
    subirImagenContactanos () {
      this.setCargandoAccion(true)
      this.subirImagen(this.preImagenContactanos).then(url => {
        this.imagenContactanos = url
        this.setCargandoAccion(false)
      })
    },
    actualizarContactanos () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('contactanos').update({ imagen: this.imagenContactanos }).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    // Términos y Condiciones
    actualizarTyC () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('tyc').update(this.tyc).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    // Política de Privacidad
    actualizarPolitica () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('politica').update(this.politica).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    // General
    verPagina (titulo) {
      const menu = this.$i18n.t('Alias.' + titulo)
      this.$router.push(menu)
    },
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      this.setCargandoAccion(true)
      this.subirImagen(file).then(url => {
        Editor.insertEmbed(cursorLocation, 'image', url)
        resetUploader()
        this.setCargandoAccion(false)
      })
    },
    subirImagen (file) {
      const reader = new FileReader()
      return new Promise(resolve => {
        reader.onload = ev => {
          axios({
            method: 'post',
            url: '/subir',
            crossDomain: true,
            data: {
              image: ev.target.result,
              tipo: 'sinMarca'
            }
          })
            .then(respuesta => {
              fetch(respuesta.data).then(res => res.blob()).then(blob => {
                var uploadTask = firebase.storage().ref('utilidades').child(file.name).put(blob)
                uploadTask.on('state_changed', snapshot => {}, error => {
                  console.log(error)
                }, () => {
                  uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                    axios({
                      method: 'post',
                      url: '/eliminar',
                      crossDomain: true,
                      data: {
                        url: respuesta.data
                      }
                    })
                    resolve(downloadURL)
                  })
                })
              })
            })
            .catch(error => {
              console.log(error)
            })
        }
        reader.readAsDataURL(file)
      })
    },
    // Por Qué Registrarse
    actualizarPQR () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('utilidades').doc('pqr').update(this.pqr).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.InformacionActualizada')
        this.setCargandoAccion(false)
      })
    },
    actualizarSeccionEnvios () {
      firebase.firestore().collection('utilidades').doc('envios').update({
        envios: this.envios
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
        })
    },

    actualizarSeccionPreguntasF () {
      firebase.firestore().collection('utilidades').doc('faq').update({
        faq: this.faq
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
        })
    },

    actualizarSeccionPorQueComprar () {
      firebase.firestore().collection('utilidades').doc('compromisos').update({
        compromisos: this.compromisos
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
        })
    }
  },
  watch: {
    panel (nuevo, viejo) {
      switch (nuevo) {
        case 0:
        // Quienes Somos
          if (!this.contenidoEsQuienesSomos) {
            firebase.firestore().collection('utilidades').doc('quienesSomos').get().then(info => {
              this.contenidoEsQuienesSomos = info.data().contenidoEs
              this.contenidoEnQuienesSomos = info.data().contenidoEn
              this.equipoQuienesSomos = info.data().equipo
            })
          }
          break
        case 1:
          // Envios y devoluciones
          if (!this.envios[0]) {
            firebase.firestore().collection('utilidades').doc('envios').get().then(info => {
              this.envios = info.data().envios
              this.reorganizar1('envios')
            })
          }
          break
        case 2:
          // Preguntas Frecuentes
          if (!this.faq[0]) {
            firebase.firestore().collection('utilidades').doc('faq').get().then(info => {
              this.faq = info.data().faq
              this.reorganizar1('faq')
            })
          }
          break
        case 3:
          // Por Qué Comprar
          if (!this.compromisos[0]) {
            firebase.firestore().collection('utilidades').doc('compromisos').get().then(info => {
              this.compromisos = info.data().compromisos
              this.reorganizar1('compromisos')
            })
          }
          break
        case 4:
          // Club
          if (!this.club) {
            firebase.firestore().collection('utilidades').doc('club').get().then(info => {
              this.club = info.data()
            })
          }
          break
        case 5:
          // Empresas
          if (!this.empresas) {
            firebase.firestore().collection('utilidades').doc('empresas').get().then(info => {
              this.empresas = info.data()
            })
          }
          break
        case 6:
          // Asesoría
          if (!this.asesoria) {
            firebase.firestore().collection('utilidades').doc('asesoria').get().then(info => {
              this.asesoria = info.data()
            })
          }
          break
        case 7:
          // Newsletter
          if (!this.newsletter) {
            firebase.firestore().collection('utilidades').doc('newsletter').get().then(info => {
              this.newsletter = info.data()
            })
          }
          break
        case 8:
          // Contactanos
          if (!this.imagenContactanos) {
            firebase.firestore().collection('utilidades').doc('contactanos').get().then(info => {
              this.imagenContactanos = info.data().imagen
            })
          }
          break
        case 9:
          // Términos y Condiciones
          if (!this.tyc) {
            firebase.firestore().collection('utilidades').doc('tyc').get().then(info => {
              this.tyc = info.data()
            })
          }
          break
        case 10:
          // Política
          if (!this.politica) {
            firebase.firestore().collection('utilidades').doc('politica').get().then(info => {
              this.politica = info.data()
            })
          }
          break
        case 11:
          // Por Qué Registrarse
          if (!this.pqr) {
            firebase.firestore().collection('utilidades').doc('pqr').get().then(info => {
              this.pqr = info.data()
            })
          }
          break
      }
    }
  }
  // mounted () {
  //   firebase.firestore().collection('utilidades').doc('envios').get().then(info => {
  //     this.envios = info.data().envios
  //     this.$nextTick(() => {
  //       this.reorganizar('envios')
  //     })
  //   })
  // }
}
</script>
